(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * 512VINTAGE:
   * Verfügbare Produkte zuerst,
   * ausverkaufte Produkte danach.
   */
  function sortV512AvailableFirst(resultsList) {
    if (!resultsList) return;

    const cards = Array.from(
      resultsList.querySelectorAll(
        '.product-grid__item[data-available]'
      )
    );

    const parents = new Set(
      cards.map((card) => card.parentElement).filter(Boolean)
    );

    parents.forEach((parent) => {
      const currentCards = Array.from(parent.children).filter(
        (element) =>
          element.matches &&
          element.matches('.product-grid__item[data-available]')
      );

      if (currentCards.length < 2) return;

      const sortedCards = currentCards.slice().sort((a, b) => {
        const aAvailable = a.dataset.available === 'true' ? 1 : 0;
        const bAvailable = b.dataset.available === 'true' ? 1 : 0;

        return bAvailable - aAvailable;
      });

      const alreadySorted = sortedCards.every(
        (card, index) => card === currentCards[index]
      );

      if (!alreadySorted) {
        sortedCards.forEach((card) => {
          parent.appendChild(card);
        });
      }
    });
  }

  function initV512ProductSorting() {
    const resultsLists = document.querySelectorAll('results-list');

    resultsLists.forEach((resultsList) => {
      sortV512AvailableFirst(resultsList);

      if (resultsList.dataset.v512SortObserver === 'true') {
        return;
      }

      resultsList.dataset.v512SortObserver = 'true';

      const observer = new MutationObserver(() => {
        sortV512AvailableFirst(resultsList);
      });

      observer.observe(resultsList, {
        childList: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initV512ProductSorting,
      { once: true }
    );
  } else {
    initV512ProductSorting();
  }

  } catch(e) { console.error(e); }
})();
})();
